import * as ActionTypes from '../../actions/types/website/WebsitePreviewActionTypes';

const initialState = {
  title: '',
  description: '',
  hidden: false,
  header_image_url: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.UPDATE_PREVIEW: {
      return action.payload;
    }
    default:
      break;
  }
  return state;
};
